// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c240-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    background-color: rgba(255, 255, 255, 0.9);
    padding: 30px;
    z-index: 1000;
}

.c240-header .controls {
    display: flex;
    justify-content: space-between;
}

.c240-header > div:last-child {
    margin-left: auto;
}

.c240-header > div:nth-child(2) {
    margin-left: 10px; /* Adjust this value to control the spacing between the first and second child */
}

.controls button {
    margin: 10px;
    transition: border-width 0.2s linear
}


.scanner-controls-container {
    position: absolute;
    bottom: 0;
    right: 0;
    bottom: 5px;
    overflow-y: scroll;
    z-index: 99999;
}

.status-bar {
    width: 400px;
    background-color: #E7F4FC;
    border-radius: 4px;
    padding: 10px;
}

.shutdown-scanner-btn {
    background-color: #dc3545;
    color: aliceblue;
    border-color: #dc3545;
}

.shutdown-scanner-btn:hover {
    background-color: #dc3545;
    color: aliceblue;
    border-color: #dc3545;
}

.open-gate-btn {
    background-color: #17202A;
    border-color: #17202A;
    color: aliceblue;
}

.open-gate-btn:hover {
    background-color: #17202A;
    border-color: #17202A;
    color: aliceblue;
}

.open-gate-btn:disabled{
    color: white !important ;
    background-color: gray !important;
}`, "",{"version":3,"sources":["webpack://./src/view/c240/c240_header.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,0CAA0C;IAC1C,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB,EAAE,gFAAgF;AACvG;;AAEA;IACI,YAAY;IACZ;AACJ;;;AAGA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,iCAAiC;AACrC","sourcesContent":[".c240-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 50px;\n    background-color: rgba(255, 255, 255, 0.9);\n    padding: 30px;\n    z-index: 1000;\n}\n\n.c240-header .controls {\n    display: flex;\n    justify-content: space-between;\n}\n\n.c240-header > div:last-child {\n    margin-left: auto;\n}\n\n.c240-header > div:nth-child(2) {\n    margin-left: 10px; /* Adjust this value to control the spacing between the first and second child */\n}\n\n.controls button {\n    margin: 10px;\n    transition: border-width 0.2s linear\n}\n\n\n.scanner-controls-container {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    bottom: 5px;\n    overflow-y: scroll;\n    z-index: 99999;\n}\n\n.status-bar {\n    width: 400px;\n    background-color: #E7F4FC;\n    border-radius: 4px;\n    padding: 10px;\n}\n\n.shutdown-scanner-btn {\n    background-color: #dc3545;\n    color: aliceblue;\n    border-color: #dc3545;\n}\n\n.shutdown-scanner-btn:hover {\n    background-color: #dc3545;\n    color: aliceblue;\n    border-color: #dc3545;\n}\n\n.open-gate-btn {\n    background-color: #17202A;\n    border-color: #17202A;\n    color: aliceblue;\n}\n\n.open-gate-btn:hover {\n    background-color: #17202A;\n    border-color: #17202A;\n    color: aliceblue;\n}\n\n.open-gate-btn:disabled{\n    color: white !important ;\n    background-color: gray !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
